import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidatedTokenService {

  get jwt() {
    const token = localStorage.getItem('token');
    return token;
  }

  DOMParser(strToSanitize: string): string {
    const { body } = new DOMParser().parseFromString(strToSanitize, 'text/html');
    return body.textContent || '';
  }
}
